"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wholeNumberPercent = void 0;
var wholeNumberPercent = function (part, total) {
    if (part === 0 && total === 0) {
        return 0;
    }
    var fixedPercent = ((part / total) * 100).toFixed();
    return Number(fixedPercent);
};
exports.wholeNumberPercent = wholeNumberPercent;
//# sourceMappingURL=wholeNumberPercent.js.map